import { render, staticRenderFns } from "./UserProductieConfiguratorCalledStats.vue?vue&type=template&id=57087812"
import script from "./UserProductieConfiguratorCalledStats.vue?vue&type=script&lang=js"
export * from "./UserProductieConfiguratorCalledStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports